import React from "react";
import styles from "./closeButton.module.scss";
import { ReactComponent as CancelIcon } from "static/images/cancel.svg";

const defaultIcon = <CancelIcon className={styles.closeIcon} />;

const CloseButton = ({ icon = defaultIcon, onClick, ...props }) => {
	return (
		<button
			type="button"
			className={styles.closeBtn}
			onClick={onClick}
			{...props}
		>
			{icon}
		</button>
	);
};

export default CloseButton;
